/*!

=========================================================
* Paper Dashboard PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-pro-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import { NavLink } from "react-router-dom";
import {
  Nav,
  Collapse,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle, faTimes } from "@fortawesome/free-solid-svg-icons";

import avatar from "../../assets/img/faces/ayo-ogunseinde-2.jpg";
import logo from "../../assets/img/sortdlogo.png";
import UserContext from '../../UserContext';

var ps;

class Sidebar extends React.Component {
  static contextType = UserContext;

  constructor(props) {
    super(props);
    this.state = {
      ...this.getCollapseStates(props.routes),
      logoutModal: false,
      searchQuery: "",
      preSearchState: {}
    };
  }
  // this creates the intial state of this component based on the collapse routes
  // that it gets through this.props.routes
  getCollapseStates = (routes) => {
    let initialState = {};
    routes.map((prop, key) => {
      if (prop.collapse) {
        initialState = {
          [prop.state]: this.getCollapseInitialState(prop.views),
          ...this.getCollapseStates(prop.views),
          ...initialState,
        };
      }
      return null;
    });
    return initialState;
  };
  // this verifies if any of the collapses should be default opened on a rerender of this component
  // for example, on the refresh of the page,
  // while on the src/views/forms/RegularForms.js - route /admin/regular-forms
  getCollapseInitialState(routes) {
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse && this.getCollapseInitialState(routes[i].views)) {
        return true;
      } else if (window.location.pathname.indexOf(routes[i].path) !== -1) {
        return true;
      }else return false;
    }
    return false;
  }
  // this function creates the links and collapses that appear in the sidebar (left menu)
  createLinks = (routes) => {
    return routes.map((prop, key) => {
      if (prop.redirect) {
        return null;
      }
      if (prop.collapse) {
        var st = {};
        st[prop["state"]] = !this.state[prop.state];
        return (
          <li
            style = {prop.visible !== false ? {display:''} : {display:'none'}}
            className={this.getCollapseInitialState(prop.views) ? "active" : ""}
            key={key}
          >
            <a
              href="#pablo"
              data-toggle="collapse"
              aria-expanded={this.state[prop.state]}
              onClick={(e) => {
                e.preventDefault();
                this.setState(st);
              }}
            >
              {prop.icon !== undefined ? (
                <>
                  <i className={prop.icon} />
                  <p>
                    {prop.name}
                    <b className="caret" />
                  </p>
                </>
              ) : (
                <>
                  <span className="sidebar-mini-icon">{prop.mini}</span>
                  <span className="sidebar-normal">
                    {prop.name}
                    <b className="caret" />
                  </span>
                </>
              )}
            </a>
            <Collapse isOpen={this.state[prop.state]}>
              <ul className="nav">{this.createLinks(prop.views)}</ul>
            </Collapse>
          </li>
        );
      }
      return (
        <li style = {prop.visible !== false ? {display:''} : {display:'none'}} className={this.activeRoute(prop.layout + prop.path)} key={key}>
          <NavLink to={prop.layout + prop.path} activeClassName="">
            {prop.icon !== undefined ? (
              <>
                <i className={prop.icon} />
                <p>{prop.name}</p>
              </>
            ) : (
              <>
                <span className="sidebar-mini-icon">{prop.mini}</span>
                <span className="sidebar-normal">{prop.name}</span>
              </>
            )}
          </NavLink>
        </li>
      );
    });
  };
  // verifies if routeName is the one active (in browser input)
  activeRoute = (routeName) => {
    return this.props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
  };
  filterRoutes = (routes, query) => {
  if (!query) return { filtered: routes, expandKeys: [] };

  let expandKeys = [];
  const lowercaseQuery = query.toLowerCase();

  const filter = (items) => {
    return items
      .map((route) => {
        // Handle Nested Folders (Collapses)
        if (route.collapse && route.views) {
          const filteredChildren = filter(route.views);
          if (filteredChildren.length > 0) {
            expandKeys.push(route.state); // Mark this parent to be opened
            return { ...route, views: filteredChildren, visible: true };
          }
        }

        // Handle Leaf Nodes (Individual Links)
        const nameMatches = route.name && route.name.toLowerCase().includes(lowercaseQuery);
        // Only return if it matches AND isn't hard-hidden by permissions
        if (nameMatches && route.visible !== false) {
          return { ...route, visible: true };
        }
        return null;
      })
      .filter((route) => route !== null);
  };

  return { filtered: filter(routes), expandKeys };
};

  toggleLogoutModal = () => {
    this.setState({
      logoutModal: !this.state.logoutModal,
    });
  };
  handleLogout = () => {
    window.location.href = "/auth/logout";
  };
  componentDidMount() {
    // if you are using a Windows Machine, the scrollbars will have a Mac look
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(this.refs.sidebar, {
        suppressScrollX: true,
        suppressScrollY: false,
      });
    }
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevState.searchQuery !== this.state.searchQuery && ps) {
      ps.update();
    }
  }

  componentWillUnmount() {
    // we need to destroy the false scrollbar when we navigate
    // to a page that doesn't have this component rendered
    if (navigator.platform.indexOf("Win") > -1) {
      ps.destroy();
    }
  }
  handleSearchChange = (e) => {
  const query = e.target.value;
  const { expandKeys } = this.filterRoutes(this.props.routes, query);
  
  let nextState = { searchQuery: query };

  if (query.length > 0) {
    if (this.state.searchQuery === "") {
      const currentState = {};
      Object.keys(this.state).forEach(key => {
        if (typeof this.state[key] === 'boolean' && key !== 'logoutModal') {
          currentState[key] = this.state[key];
        }
      });
      nextState.preSearchState = currentState;
    }

    this.props.routes.forEach(prop => {
      if (prop.collapse) nextState[prop.state] = false;
    });

    expandKeys.forEach(key => {
      nextState[key] = true; 
    });
  } else {
    nextState = { 
      ...nextState, 
      ...this.state.preSearchState,
      searchQuery: "" 
    };
  }

  this.setState(nextState);
};
  render() {    
    let userDetails = this.context;
    const { filtered: filteredRoutes } = this.filterRoutes(this.props.routes, this.state.searchQuery);
    return (
      <div
        className="sidebar"
        data-color={this.props.bgColor}
        data-active-color={this.props.activeColor}
      >
        <Modal
          isOpen={this.state.logoutModal}
          toggle={this.toggleLogoutModal}
          centered
        >
          <ModalHeader className="justify-content-center border-0 pb-0">
            Confirm Logout
          </ModalHeader>
          <ModalBody className="text-center pt-4">
            <FontAwesomeIcon
              icon={faExclamationTriangle}
              size="3x"
              className="text-warning mb-3"
            />
            <h4>Are you sure you want to log out?</h4>
            <p className="text-muted">
              You will need to sign in again to access your account.
            </p>
          </ModalBody>
          <ModalFooter className="justify-content-center border-0 pt-0">
            <Button
              color="danger"
              onClick={this.handleLogout}
              style={{ minWidth: "120px" }}
            >
              Yes, Logout
            </Button>
            <Button
              color="secondary"
              outline
              onClick={this.toggleLogoutModal}
              style={{ minWidth: "120px" }}
            >
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
        <div className="logo">
          <a
            href="/dashboard/home"
            className="simple-text logo-mini"
          >
            <div className="logo-img">
              <img src={logo} alt="react-logo" />
            </div>
          </a>
          <a
            href="/dashboard/home"
            className="simple-text logo-normal"
          >
            SORTD
          </a>
        </div>

        <div className="sidebar-wrapper" ref="sidebar" style={{ 
          display: "flex", 
          flexDirection: "column",
          paddingBottom: "0px" 
        }}>
          <div style={{ 
            position: "sticky", 
            backgroundColor: "#2c2c2c", 
            top: 0, 
            zIndex: 10, 
            paddingTop: "1px",
            boxShadow: "0 10px 10px -10px rgba(0,0,0,0.5)",
            flexShrink: 0
          }}>
          <div className="user">
            <div className="photo">
              {/* <img src={avatar} alt="Avatar" /> */}
              <img src={userDetails.picture} alt="Avatar" />
            </div>
            <div className="info">
              <a
                href="#pablo"
                data-toggle="collapse"
                aria-expanded={this.state.openAvatar}
                onClick={() =>
                  this.setState({ openAvatar: !this.state.openAvatar })
                }
              >
                <span>
                {userDetails.name}
                  <b className="caret" />
                </span>
              </a>
              <Collapse isOpen={this.state.openAvatar}>
                <ul className="nav">
                  <li>
                    <a
                      href="#pablo"
                      onClick={(e) => {
                        e.preventDefault();
                        this.toggleLogoutModal();
                      }}
                    >
                      <span className="sidebar-mini-icon">L</span>
                      <span className="sidebar-normal">Logout</span>
                    </a>
                  </li>
                </ul>
              </Collapse>
            </div>
          </div>
            <div style={{ padding: "0 15px 15px 15px", position: "relative" }}>
              <input
                type="text"
                className="form-control"
                placeholder="Search menu..."
                value={this.state.searchQuery}
                style={{ 
                  borderRadius: "20px", 
                  backgroundColor: "rgba(255,255,255,0.1)", 
                  color: "white",
                  border: "1px solid rgba(255,255,255,0.2)",
                  paddingRight: "40px",
                  outline: "none"
                }}
               onChange={this.handleSearchChange}
              />
              {this.state.searchQuery && (
                <div 
                    onClick={() => this.handleSearchChange({ target: { value: "" } })}
                    style={{
                        position: "absolute",
                        right: "25px",
                        top: "50%",
                        transform: "translateY(-75%)",
                        cursor: "pointer",
                        color: "rgba(255,255,255,0.6)",
                        zIndex: 20,
                        padding: "5px"
                    }}
                >
                    <FontAwesomeIcon icon={faTimes} />
                </div>
              )}
            </div>
          </div>

          <Nav style={{flexGrow: 1, paddingBottom: "5px",marginBottom: "0px",marginTop: "0px"}}>{this.createLinks(filteredRoutes)}</Nav>
        </div>
      </div>
    );
  }
}

export default Sidebar;
